import React, {PropTypes} from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import Search from 'material-ui/svg-icons/action/search';

export default function LibrarySearch({materialTitles, onSearchRequest, onInputUpdate, onKeyPressUpdate, searchString}) {
  return (
    <div className="library-search-container">
      <div className="library-search-icon">
        <Search />
      </div>
      <div className="library-search-autocomplete">
        <AutoComplete
          hintText="Search"
          filter={AutoComplete.fuzzyFilter}
          dataSource={materialTitles}
          maxSearchResults={5}
          fullWidth
          onNewRequest={onSearchRequest}
          onUpdateInput={onInputUpdate}
          onKeyPress={onKeyPressUpdate}
          searchText={searchString} />
      </div>
    </div>
  );
}

LibrarySearch.propTypes = {
  materialTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchString: PropTypes.string.isRequired,
  onSearchRequest: PropTypes.func.isRequired,
  onInputUpdate: PropTypes.func.isRequired,
  onKeyPressUpdate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/library/components/LibrarySearch.js